import _ from 'lodash';

export function* reportWriteError(error, put) {
  if (!error?.message) return;
  const next = error;
  if (next.validationErrors && _.isEmpty(next.validationErrors[0]?.field)) {
    _.set(next, 'message', next.validationErrors[0].errorMessages?.[0] || next.message);
  }
  yield put({
    type: 'global/showNotificationsForm',
    payload: { visible: true, type: 'error', message: next.message },
    validationErrors: next.validationErrors || [],
  });
  yield put({
    type: 'errors',
    payload: { validationErrors: next.validationErrors || [], message: next.message },
  });
}

export function* notifyGlobal(put, payload) {
  yield put({
    type: 'global/showNotificationsGlobal',
    payload: { visible: true, ...payload },
  });
}
